import * as React from "react";
import type { SVGProps } from "react";

interface SevenMeterProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const SevenMeter = ({ cancelled = false, ...props }: SevenMeterProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        d="M20.65 5.25C21.95 5.25 23 6.3 23 7.6v10.94c0 .69-.56 1.25-1.25 1.25h-.37c-.62 0-1.13-.45-1.23-1.04H3.35c-.1.55-.54.98-1.1 1.03h-.5c-.69 0-1.25-.55-1.25-1.24V7.6c0-1.3 1.05-2.35 2.35-2.35Z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M20.65 6c.88 0 1.6.72 1.6 1.6v10.94a.5.5 0 0 1-.5.5h-.37a.5.5 0 0 1-.5-.5V7.6c0-.13-.1-.23-.23-.23H2.85c-.13 0-.23.1-.23.23v10.94a.5.5 0 0 1-.5.5h-.37a.5.5 0 0 1-.5-.5V7.6c0-.88.72-1.6 1.6-1.6z"
      />
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M7.25 17.38c-.2 0-.35-.06-.45-.2-.1-.13-.12-.31-.07-.54a27 27 0 0 1 .74-2.76 50 50 0 0 1 .93-2.72H6.2c-.47 0-.71-.2-.71-.58 0-.39.24-.58.71-.58h2.88c.48 0 .71.15.71.44 0 .16 0 .3-.04.43-.03.13-.07.27-.13.43l-.17.45a36 36 0 0 0-1.11 3.7c-.13.48-.23.92-.32 1.31-.09.42-.35.62-.78.62Zm4.08 0c-.47 0-.7-.23-.7-.7V10.7c0-.27.06-.45.2-.55q.225-.15.63-.15c.38 0 .66.16.84.47l1.77 3.01 1.74-3c.12-.2.25-.32.4-.39.14-.06.34-.09.58-.09.47 0 .71.23.71.7v5.99c0 .46-.24.7-.71.7s-.71-.24-.71-.7v-4.32l-1.34 2.39c-.17.32-.4.48-.68.48-.3 0-.52-.16-.7-.48l-1.33-2.39v4.32c0 .46-.23.7-.7.7Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default SevenMeter;
